<template>
    <div
        id="judges-page"
        class="page-content"
        :class="$mq"
        data-aos="fade-in"
        data-aos-duration="700"
        data-aos-easing="ease-in-out"
        data-aos-once="true"
    >
        <base-text type="h3" class="heading">{{ data.heading }}</base-text>
        <div class="judges-grid">
            <team-member
                v-for="(judge, index) in data.judges"
                :key="index"
                :name="judge.name"
                :position="judge.position"
                :portfolio="judge.weblink || null"
                :photo="judge.photo"
            />
        </div>
    </div>
</template>

<script>
    // CMS DATA LOADING
    import dataLoader from '../mixins/dataLoader';
    import data from '../content/pages/judges.md';
    import TeamMember from '../components/TeamMember';

    export default {
        name: 'judges',

        mixins: [dataLoader(data)],

        components: {
            TeamMember,
        },
    };
</script>

<style lang="scss" scoped>
    #judges-page {
        margin: 150px 0;

        &.tablet,
        &.mobile {
            margin: 100px 0;
        }

        .heading {
            margin-bottom: $standard-space;
        }

        &.mobile {
            .heading {
                margin-bottom: $standard-space-mobile;
            }
        }

        .judges-grid {
            display: grid;
            grid-gap: 30px;
            grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
        }

        &.tablet,
        &.mobile {
            .judges-grid {
                grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
            }
        }
    }
</style>
